import { getAgGridFilter } from './AgGridHelpers';
import { SvgIcon } from '@material-ui/core';
import config from '../../../config.json';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const CustomHeader = (props) => {
    const { displayName, column } = props;

    return (
        <div className="ag-header-cell-label" role="presentation">
            {
                column.colDef.headerComponentParams.isPrimaryKey &&
                <>
                    <SvgIcon fontSize="small">
                        <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
                    </SvgIcon>
                    &nbsp; {/*space*/}
                </>
            }
            
            <span 
                ref={props.eText}
                className="ag-header-cell-text" 
                role="columnheader"
            >
                {displayName}
            </span>
        </div>
    );
};

const notEditableCols = ["LastModifiedBy", "LastModifiedDate"];

export const getAgGridOptions = (table, { showColumnTypes, editable, columnDefs }) => {
    const userState = table && table.userState ? JSON.parse(table.userState) : null;
    const getColumnVisiblity = (columnName) => {
        if (!userState || !userState.visibility) return true;
        const visibility = userState.visibility[columnName];
        return visibility ?? true;
    }
    return !table ? {} : {
        styleNonce: config.agGrid.nonce,
        theme: 'alpine',
        rowModelType: "serverSide",
        rowSelection: "multiple",
        cellSelection: true,
        enableRangeHandle: true,
        editType: "fullRow",
        stopEditingWhenCellsLoseFocus: true,
        suppressFieldDotNotation: true,
        rowClassRules: {
            "row-with-changes": (params) => {
                return (params.data && params.data.isChanged && !params.data.error);
            },
            "row-with-errors": (params) => {
                return (params.data && params.data.error);
            },
        },
        columnDefs: table.columns ? table.columns.map((column, index) => ({
            ...(columnDefs ? columnDefs[column.name] : {}),
            field: column.name,
            checkboxSelection: editable && index === 0,
            editable: !column.isIdentity && editable && !notEditableCols.includes(column.name),
            headerName: showColumnTypes ? `${column.name} (${column.sqlType}${column.isNullable ? "?" : "!"})` : column.name,
            headerComponentParams: {
                isPrimaryKey: column.isPrimaryKey,
                innerHeaderComponent: CustomHeader
            },
            hide: !getColumnVisiblity(column.name),
            pinned: userState && userState.pins ? userState.pins[column.name] ?? "" : "",
            ...(getAgGridFilter(column.sqlType)),
            tooltipValueGetter: (params) => {
                if (params.data.error) {
                    if (params.data.errorInfo
                        && params.data.errorInfo.ColumnName === params.colDef.field) {
                        return params.data.error;
                    } else if (column.isPrimaryKey) {
                        return params.data.error;
                    }
                } else {
                    return null;
                }
            },
            cellClassRules: {
                "cell-primary-key": (params) => {
                    return (column.isPrimaryKey && !params.data.error);
                },
                "cell-identity": (params) => {
                    return (column.isIdentity && !params.data.error);
                },
                "cell-with-error": (params) => {
                    return (
                        params.data.error
                        && ((!params.data.errorInfo && column.isPrimaryKey)
                            || (params.data.errorInfo && params.data.errorInfo.ColumnName === params.colDef.field))
                    );
                },
                "cell-not-editable": () => {
                    return (
                        notEditableCols.includes(column.name));
                }
            }
        })) : [{ field: "No Columns" }],
        sideBar: {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: true,
                        suppressColumnFilter: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true,
                    },
                },
                {
                    id: 'filters',
                    labelDefault: 'Filters',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel'
                }
            ],
            position: 'left'
        },
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: false,
            editable: editable
        }
    }
};